export { ProductsV2Connected as ProductsV2 } from './container';
